/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
} from "@angular/common/http";
import {CustomHttpParameterCodec} from "../encoder";
import {Observable} from "rxjs";

import {ProjectCreateUpdateDto} from "../model/models";
import {ProjectDto} from "../model/models";
import {ProjectSummaryDto} from "../model/models";

import {BASE_PATH, COLLECTION_FORMATS} from "../variables";
import {Configuration} from "../configuration";
import {ProjectControllerBackendServiceInterface} from "./projectController.serviceInterface";

@Injectable({
  providedIn: "root",
})
export class ProjectControllerBackendService implements ProjectControllerBackendServiceInterface {
  protected basePath = "http://localhost:8080";
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration,
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== "string") {
      if (typeof basePath !== "string") {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === "object" && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === "object") {
      if (Array.isArray(value)) {
        (value as any[]).forEach(
          (elem) => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)),
        );
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substr(0, 10));
        } else {
          throw Error("key may not be null if value is Date");
        }
      } else {
        Object.keys(value).forEach(
          (k) =>
            (httpParams = this.addToHttpParamsRecursive(
              httpParams,
              value[k],
              key != null ? `${key}.${k}` : k,
            )),
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error("key may not be null if value is not object or array");
    }
    return httpParams;
  }

  /**
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public archiveProject(
    id: number,
    observe?: "body",
    reportProgress?: boolean,
    options?: {httpHeaderAccept?: undefined},
  ): Observable<any>;
  public archiveProject(
    id: number,
    observe?: "response",
    reportProgress?: boolean,
    options?: {httpHeaderAccept?: undefined},
  ): Observable<HttpResponse<any>>;
  public archiveProject(
    id: number,
    observe?: "events",
    reportProgress?: boolean,
    options?: {httpHeaderAccept?: undefined},
  ): Observable<HttpEvent<any>>;
  public archiveProject(
    id: number,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {httpHeaderAccept?: undefined},
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error("Required parameter id was null or undefined when calling archiveProject.");
    }

    let headers = this.defaultHeaders;

    let credential: string | undefined;
    // authentication (OAuth) required
    credential = this.configuration.lookupCredential("OAuth");
    if (credential) {
      headers = headers.set("Authorization", "Bearer " + credential);
    }

    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith("text")) {
      responseType = "text";
    }

    return this.httpClient.put<any>(
      `${this.configuration.basePath}/v1/projects/${encodeURIComponent(String(id))}/archive`,
      null,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * @param projectCreateUpdateDto
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createProject(
    projectCreateUpdateDto: ProjectCreateUpdateDto,
    observe?: "body",
    reportProgress?: boolean,
    options?: {httpHeaderAccept?: "application/json"},
  ): Observable<number>;
  public createProject(
    projectCreateUpdateDto: ProjectCreateUpdateDto,
    observe?: "response",
    reportProgress?: boolean,
    options?: {httpHeaderAccept?: "application/json"},
  ): Observable<HttpResponse<number>>;
  public createProject(
    projectCreateUpdateDto: ProjectCreateUpdateDto,
    observe?: "events",
    reportProgress?: boolean,
    options?: {httpHeaderAccept?: "application/json"},
  ): Observable<HttpEvent<number>>;
  public createProject(
    projectCreateUpdateDto: ProjectCreateUpdateDto,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {httpHeaderAccept?: "application/json"},
  ): Observable<any> {
    if (projectCreateUpdateDto === null || projectCreateUpdateDto === undefined) {
      throw new Error(
        "Required parameter projectCreateUpdateDto was null or undefined when calling createProject.",
      );
    }

    let headers = this.defaultHeaders;

    let credential: string | undefined;
    // authentication (OAuth) required
    credential = this.configuration.lookupCredential("OAuth");
    if (credential) {
      headers = headers.set("Authorization", "Bearer " + credential);
    }

    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ["application/json"];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ["application/json"];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    let responseType: "text" | "json" = "json";
    if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith("text")) {
      responseType = "text";
    }

    return this.httpClient.post<number>(
      `${this.configuration.basePath}/v1/projects`,
      projectCreateUpdateDto,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * @param projectId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteProject(
    projectId: number,
    observe?: "body",
    reportProgress?: boolean,
    options?: {httpHeaderAccept?: undefined},
  ): Observable<any>;
  public deleteProject(
    projectId: number,
    observe?: "response",
    reportProgress?: boolean,
    options?: {httpHeaderAccept?: undefined},
  ): Observable<HttpResponse<any>>;
  public deleteProject(
    projectId: number,
    observe?: "events",
    reportProgress?: boolean,
    options?: {httpHeaderAccept?: undefined},
  ): Observable<HttpEvent<any>>;
  public deleteProject(
    projectId: number,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {httpHeaderAccept?: undefined},
  ): Observable<any> {
    if (projectId === null || projectId === undefined) {
      throw new Error(
        "Required parameter projectId was null or undefined when calling deleteProject.",
      );
    }

    let headers = this.defaultHeaders;

    let credential: string | undefined;
    // authentication (OAuth) required
    credential = this.configuration.lookupCredential("OAuth");
    if (credential) {
      headers = headers.set("Authorization", "Bearer " + credential);
    }

    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith("text")) {
      responseType = "text";
    }

    return this.httpClient.delete<any>(
      `${this.configuration.basePath}/v1/projects/${encodeURIComponent(String(projectId))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAllProjects(
    observe?: "body",
    reportProgress?: boolean,
    options?: {httpHeaderAccept?: "application/json"},
  ): Observable<Array<ProjectSummaryDto>>;
  public getAllProjects(
    observe?: "response",
    reportProgress?: boolean,
    options?: {httpHeaderAccept?: "application/json"},
  ): Observable<HttpResponse<Array<ProjectSummaryDto>>>;
  public getAllProjects(
    observe?: "events",
    reportProgress?: boolean,
    options?: {httpHeaderAccept?: "application/json"},
  ): Observable<HttpEvent<Array<ProjectSummaryDto>>>;
  public getAllProjects(
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {httpHeaderAccept?: "application/json"},
  ): Observable<any> {
    let headers = this.defaultHeaders;

    let credential: string | undefined;
    // authentication (OAuth) required
    credential = this.configuration.lookupCredential("OAuth");
    if (credential) {
      headers = headers.set("Authorization", "Bearer " + credential);
    }

    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ["application/json"];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith("text")) {
      responseType = "text";
    }

    return this.httpClient.get<Array<ProjectSummaryDto>>(
      `${this.configuration.basePath}/v1/projects`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * @param projectId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getProject(
    projectId: number,
    observe?: "body",
    reportProgress?: boolean,
    options?: {httpHeaderAccept?: "application/json"},
  ): Observable<ProjectDto>;
  public getProject(
    projectId: number,
    observe?: "response",
    reportProgress?: boolean,
    options?: {httpHeaderAccept?: "application/json"},
  ): Observable<HttpResponse<ProjectDto>>;
  public getProject(
    projectId: number,
    observe?: "events",
    reportProgress?: boolean,
    options?: {httpHeaderAccept?: "application/json"},
  ): Observable<HttpEvent<ProjectDto>>;
  public getProject(
    projectId: number,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {httpHeaderAccept?: "application/json"},
  ): Observable<any> {
    if (projectId === null || projectId === undefined) {
      throw new Error(
        "Required parameter projectId was null or undefined when calling getProject.",
      );
    }

    let headers = this.defaultHeaders;

    let credential: string | undefined;
    // authentication (OAuth) required
    credential = this.configuration.lookupCredential("OAuth");
    if (credential) {
      headers = headers.set("Authorization", "Bearer " + credential);
    }

    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ["application/json"];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith("text")) {
      responseType = "text";
    }

    return this.httpClient.get<ProjectDto>(
      `${this.configuration.basePath}/v1/projects/${encodeURIComponent(String(projectId))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public unarchiveProject(
    id: number,
    observe?: "body",
    reportProgress?: boolean,
    options?: {httpHeaderAccept?: undefined},
  ): Observable<any>;
  public unarchiveProject(
    id: number,
    observe?: "response",
    reportProgress?: boolean,
    options?: {httpHeaderAccept?: undefined},
  ): Observable<HttpResponse<any>>;
  public unarchiveProject(
    id: number,
    observe?: "events",
    reportProgress?: boolean,
    options?: {httpHeaderAccept?: undefined},
  ): Observable<HttpEvent<any>>;
  public unarchiveProject(
    id: number,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {httpHeaderAccept?: undefined},
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error("Required parameter id was null or undefined when calling unarchiveProject.");
    }

    let headers = this.defaultHeaders;

    let credential: string | undefined;
    // authentication (OAuth) required
    credential = this.configuration.lookupCredential("OAuth");
    if (credential) {
      headers = headers.set("Authorization", "Bearer " + credential);
    }

    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith("text")) {
      responseType = "text";
    }

    return this.httpClient.put<any>(
      `${this.configuration.basePath}/v1/projects/${encodeURIComponent(String(id))}/unarchive`,
      null,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * @param id
   * @param projectCreateUpdateDto
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateProject(
    id: number,
    projectCreateUpdateDto: ProjectCreateUpdateDto,
    observe?: "body",
    reportProgress?: boolean,
    options?: {httpHeaderAccept?: undefined},
  ): Observable<any>;
  public updateProject(
    id: number,
    projectCreateUpdateDto: ProjectCreateUpdateDto,
    observe?: "response",
    reportProgress?: boolean,
    options?: {httpHeaderAccept?: undefined},
  ): Observable<HttpResponse<any>>;
  public updateProject(
    id: number,
    projectCreateUpdateDto: ProjectCreateUpdateDto,
    observe?: "events",
    reportProgress?: boolean,
    options?: {httpHeaderAccept?: undefined},
  ): Observable<HttpEvent<any>>;
  public updateProject(
    id: number,
    projectCreateUpdateDto: ProjectCreateUpdateDto,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {httpHeaderAccept?: undefined},
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error("Required parameter id was null or undefined when calling updateProject.");
    }
    if (projectCreateUpdateDto === null || projectCreateUpdateDto === undefined) {
      throw new Error(
        "Required parameter projectCreateUpdateDto was null or undefined when calling updateProject.",
      );
    }

    let headers = this.defaultHeaders;

    let credential: string | undefined;
    // authentication (OAuth) required
    credential = this.configuration.lookupCredential("OAuth");
    if (credential) {
      headers = headers.set("Authorization", "Bearer " + credential);
    }

    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ["application/json"];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    let responseType: "text" | "json" = "json";
    if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith("text")) {
      responseType = "text";
    }

    return this.httpClient.put<any>(
      `${this.configuration.basePath}/v1/projects/${encodeURIComponent(String(id))}`,
      projectCreateUpdateDto,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }
}
